<template>
  <div class="smb-sales_tips">
    <img
      src="@/assets/tool-tip_icon.svg"
      width="18px"
      height="18px"
      alt=""
    />
    <div class="smb-sales_desc">
      Please be aware: The partner information provided will be used for purposes such as future order fulfillment, business communication, and partner management. Ensure that you have informed and obtained consent from the partners for their information to be used for the aforementioned purposes.
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerTips'
}
</script>

<style lang="scss" scoped>
.smb-sales_tips {
  padding-left: 34px;
  margin-bottom: 20px;
}
.tips-content {
  padding: 20px 20px 20px 24px;
  color: #a6a6a6;
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/footerTips.vue